// Lightweight content card. WHAT: bordered surface; styling via .hrms-card.
export default function Card({ title, actions, children, className = '' }) {
  return (
    <section className={`hrms-card ${className}`}>
      {(title || actions) && (
        <div className="hrms-toolbar">
          {title ? <div className="hrms-page-title" style={{ marginBottom: 0 }}>{title}</div> : <span />}
          {actions}
        </div>
      )}
      {children}
    </section>
  );
}
